import React from "react";
import "./pain-card.css";

/**
 * Reusable PainCard Component
 *
 * @param {string} title - Title of the card
 * @param {number} pain1 - Pain 1 value
 * @param {number} pain2 - Pain 2 value
 * @param {number} overall - Overall value
 * @param {number} target - Monthly target value
 * @param {string} bgColor - (optional) Background color for the card
 */
export default function PainCard({
  title,
  pain1,
  pain2,
  overall,
  target,
  bgColor = "#fff4e6", // Light orange background as default
}) {
  return (
    <div className="pain-card" style={{ backgroundColor: bgColor }}>
      {/* Card Title */}
      <h3 className="card-title">{title}</h3>

      {/* Pain Rows */}
      <div className="pain-row">
        <span>Pain 1</span>
        <span className="pain-value">{pain1}</span>
      </div>

      <div className="pain-row">
        <span>Pain 2</span>
        <span className="pain-value">{pain2}</span>
      </div>

      <hr className="divider" />

      {/* Overall Row */}
      <div className="pain-row overall">
        <span>Overall</span>
        <span className="overall-value">{overall}</span>
      </div>

      {/* Target */}
      <p className="monthly-target">Monthly Target: {target}</p>
    </div>
  );
}
